// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button, Loading } from '@carbon/react';
import { bool, func } from 'prop-types';

const StyledCookieConsent = styled.div`
  position: fixed;
  padding: 32px 0;
  background: #F3F2F2;
  color: #3a3a3a;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  display: flex;
  flex-wrap: nowrap;
  z-index: 9999;

  .content { 
    display: flex;
    align-items: center;
    padding-right: 100px;
  }

  .message {
    flex: 1;

    a {
      color: #0f62fe;
    }
  }

  .compliance {
    margin-left: 45px;

    .consentBtn {
      svg {
        margin-right: 12px;
        height: 16px;
      }
  
      .cds--loading {
        position: absolute;
        left: 10px;
        top: calc(50% - 0.5rem);
        margin: 0 0 0 5px;
        width: 1rem;
        height: 1rem;
      }
  
      min-height: 0;
      min-width: 165px;
      max-width: 280px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: ${ props => props.theme.colors.white };
      padding: 0;
    }
  }

  @media screen and (max-width: ${ props => props.theme.device.mobile }) {
    padding: 20px 0;

    .content {
      flex-direction: column;
      gap: 10px;
      align-items: flex-start;
    }

    .compliance {
      margin-left: 0;
    }
  }
`;

const CookieConsent = ({ onClick, isLoading }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <StyledCookieConsent theme={ theme }>
      <div className="grid-container content">
        <span className="message">
          { t('footer.consent.message') }
          {' '}
          <Link to="/information/cookies-policy">{ t('footer.consent.learnMore') }</Link>
        </span>
        <div className="compliance">
          <Button
            className="consentBtn"
            kind="danger"
            onClick={ onClick }
            disabled={ isLoading }
          >
            { isLoading && <Loading active small withOverlay={ false } /> }
            { t('footer.consent.gotIt') }
          </Button>
        </div>
      </div>
    </StyledCookieConsent>
  );
};

CookieConsent.propTypes = {
  onClick: func,
  isLoading: bool
};

CookieConsent.displayName = 'CookieConsentComponent';

export default CookieConsent;
